import { Component, inject, input, model } from '@angular/core';
import { Observable } from 'rxjs';

import { PieChartSize } from '../../../constants';
import { ModalService } from '../../../services';
import { PieChartComponent } from '../../charts/pie-chart/pie-chart.component';

@Component({
  selector: 'app-pie-chart-modal',
  templateUrl: './pie-chart-modal.component.html',
  styleUrl: './pie-chart-modal.component.scss',
  imports: [PieChartComponent],
})
export class PieChartModalComponent<T> {
  private readonly modalService = inject(ModalService);

  public readonly header = model('');
  public readonly subHeader = model('');
  public readonly labelKey = model<string>();
  public readonly valueKey = model<string>();
  public readonly valueFormattedKey = model<string>();
  public readonly tooltipKey = model<string>();
  public readonly showLegend = input(true);
  public readonly pieChartSize = input(PieChartSize.extraLarge);
  public readonly data = model<Observable<T[]> | T[]>();

  onClose() {
    this.modalService.dismiss();
  }
}
